"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetApprovalModal = exports.approvalFound = exports.approvalFailed = exports.resetWalletApproveState = exports.approved = exports.approving = exports.checkingApproval = exports.doApproval = exports.getApproval = void 0;
const WalletApproverWrapperSlice_1 = require("./WalletApproverWrapperSlice");
const serverRequest = __importStar(require("../../../common-client/axiosApiClient"));
const Web3Helper_1 = __importDefault(require("../../../helper/web3/Web3Helper"));
const react_hot_toast_1 = require("react-hot-toast");
// import { dispatch } from "react-hot-toast/dist/core/store";
const { actions } = WalletApproverWrapperSlice_1.walletApproverWrapperSlice;
const getApproval = (userAddress, contractAddress, currency) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield dispatch(actions.checkingApproval());
    yield serverRequest
        .getContractAllocation(userAddress, contractAddress, currency)
        .then((res) => {
        var _a;
        dispatch(actions.getApproval({
            userAddress,
            contractAddress,
            currency,
            res,
        }));
        dispatch(actions.approvalChecked());
        if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.allocation) !== "0") {
            // console.log("current selection is approved");
            dispatch(actions.approved());
        }
        else {
            // console.log(
            //   "current selection is no approve please procced to approve"
            // );
        }
    })
        .catch((err) => {
        var _a, _b;
        // console.log(err.response);
        react_hot_toast_1.toast.error(((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) ||
            "Error occured while checking for wallet approval");
        dispatch(actions.resetWalletApproveState());
        // return;
    });
});
exports.getApproval = getApproval;
const doApproval = (userAddress, contractAddress, currency, authToken, networkClient) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield dispatch(actions.approving());
    yield serverRequest
        .setContractAllocation(userAddress, contractAddress, currency, authToken)
        .then((res) => __awaiter(void 0, void 0, void 0, function* () {
        // console.log("allocation response : ", res.data);
        const web3Instance = yield new Web3Helper_1.default(networkClient);
        yield web3Instance
            .sendTransactionAsync((txId) => dispatch(actions.tranasctionIdReceived({
            transactionId: txId,
        })), res.data)
            .then((res) => {
            // console.log("Approval received : ", res);
            // console.log(JSON.stringify(res.split("|")[0]));
        })
            .catch((err) => {
            // console.log(err);
            react_hot_toast_1.toast.error((err === null || err === void 0 ? void 0 : err.message) || "Unable to approve.");
            dispatch(actions.resetWalletApproveState());
        });
    }))
        .catch((err) => {
        var _a, _b;
        // console.log(err.response);
        react_hot_toast_1.toast.error(((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) ||
            "Error occured while checking for wallet approval");
        dispatch(actions.resetWalletApproveState());
    });
});
exports.doApproval = doApproval;
const checkingApproval = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.checkingApproval());
});
exports.checkingApproval = checkingApproval;
const approving = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.approving());
});
exports.approving = approving;
const approved = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.approved());
});
exports.approved = approved;
const resetWalletApproveState = () => (dispatch) => {
    dispatch(actions.resetWalletApproveState());
};
exports.resetWalletApproveState = resetWalletApproveState;
const approvalFailed = () => (dispatch) => {
    dispatch(actions.approvalFailed());
};
exports.approvalFailed = approvalFailed;
const approvalFound = () => (dispatch) => {
    dispatch(actions.approvalFound());
};
exports.approvalFound = approvalFound;
const resetApprovalModal = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.resetApprovalModal());
});
exports.resetApprovalModal = resetApprovalModal;
//# sourceMappingURL=WalletApproverWrapperActions.js.map